import { render, staticRenderFns } from "./biReport.vue?vue&type=template&id=606f1b2d&"
import script from "./biReport.vue?vue&type=script&lang=js&"
export * from "./biReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports